import { render, staticRenderFns } from "./PatientHeader.vue?vue&type=template&id=63435d64&scoped=true"
import script from "./PatientHeader.vue?vue&type=script&lang=js"
export * from "./PatientHeader.vue?vue&type=script&lang=js"
import style0 from "./PatientHeader.vue?vue&type=style&index=0&id=63435d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63435d64",
  null
  
)

export default component.exports